/**
 * Where a signed-in user belongs when no specific destination was requested.
 *
 * Shared by the router's guards and the login view, which previously each had
 * their own copy — so agency staff landed correctly on a redirect but not on a
 * fresh sign-in.
 *
 * @param {Object} user - userAuthStore.user
 * @returns {Object|null} a router location, or null when the user has nowhere
 *   to go (no companies and no agency)
 */
export const defaultUserRoute = (user) => {
  if (!user) return null;

  if (user.type === 'admin' || user.type === 'super') {
    // Set on the Settings section of My Profile. My Work is the default.
    return {
      name: user.preferences?.defaultLandingPage === 'companies'
        ? 'admin-companies'
        : 'admin-my-work',
    };
  }

  // Agency staff belong to many companies by design, so the multi-company
  // branch below would drop them on a selector listing their whole roster.
  // Their home is the agency portal.
  if (user.agencyId) {
    return { name: 'agency-companies', params: { agencyId: user.agencyId } };
  }

  if (user.companies && user.companies.length > 1 && !user.activeCompanyId) {
    return { name: 'account-selector' };
  }

  if (user.activeCompanyId) {
    return { name: 'account-assets', params: { id: user.activeCompanyId } };
  }

  return null;
};
